import 'babel-polyfill/dist/polyfill.min'
import Swiper, { Navigation, Pagination } from 'swiper'
// import Vue from 'vue'
// import vueCustomElement from 'vue-custom-element'
// import 'document-register-element/build/document-register-element'
import 'slick-carousel'
import './abstracts/utils'
import './abstracts/events'

/**
 * import vue components
 */
// import ProductCatsListing from './components/product_cats-listing.vue'

/**
 * import abstracts, pages
 */
import navigation from './abstracts/_navigation'
import searchForm from './abstracts/_searchform'
import singleProduct from './pages/_single-product'
import pageProductCatListing from './pages/_product_cat-listing'
import pageIntroduction from './pages/_introduction'
import pageHome from './pages/_home'
import pagePriceTags from './pages/_price-tags'
import pageSearch from './pages/_search'
import pageNews from './pages/_news'
import pageRecommendedProducts from './pages/_recommended-products'
import single from './pages/_single'
import archiveProject from './pages/_archive-project'
import singleProject from './pages/_single-project'
import pageContact from './pages/_contact'

window.endpoint = '/wp-json/decormart/v1'

/**
 * register custom element, use as a DOM
 */
// Vue.use(vueCustomElement)
//
// if (document.getElementsByTagName('decormart-product-cats-listing')) {
//   Vue.customElement('decormart-product-cats-listing', ProductCatsListing)
// }

/**
 * call abstracts, pages
 */
Swiper.use([Navigation, Pagination])

navigation()
searchForm()
singleProduct()
pageProductCatListing()
pageIntroduction()
pageHome()
pagePriceTags()
pageSearch()
pageNews()
pageRecommendedProducts()
single()
archiveProject()
singleProject()
pageContact()
